


















































import { Component, Vue } from 'vue-property-decorator'
import { namespace, Getter, Action } from 'vuex-class'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import { getAnchorFromElement } from 'library/v4/components/OzPopoverModal.vue'

const wallCollectionsStore = namespace('wallCollections')

@Component({
  components: {
    OzTextButton,
    OzIcon,
  },
})
export default class SurfaceNavBookmarkButton extends Vue {
  OzTextButtonColorScheme = OzTextButtonColorScheme
  @Getter showBookmarkFolders!: boolean
  @Action bookmarkWallAndNotify
  @Action openEditBookmarksDialog
  @Action addToFavorites
  @Action removeFromFavorites

  @wallCollectionsStore.Getter isActiveWallBookmarked
  @wallCollectionsStore.Getter isActiveWallInFavorites

  editBookmarks() {
    const vue = this.$refs.bookmarkButton as Vue
    const el = vue?.$el
    const popoverAnchor = el
      ? {
          position: 'top',
          ...getAnchorFromElement(el),
        }
      : null
    this.openEditBookmarksDialog(popoverAnchor)
  }
}
